import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-2xl sm:text-3xl font-heading font-bold tracking-tight mb-4 text-ink-text">
      {title}
    </h2>
    <div className="space-y-4 text-sm sm:text-base text-muted leading-relaxed">
      {children}
    </div>
  </section>
);

export default function Legal() {
  return (
    <main className="min-h-screen bg-page text-ink-text">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16 sm:py-20">
        <div className="mb-10">
          <Link
            to="/"
            className="mono text-[11px] uppercase tracking-[0.22em] text-brand-cyan hover:text-brand-cyan/80 transition-colors"
          >
            ← На главную
          </Link>
        </div>

        <div className="glass rounded-3xl p-8 sm:p-10 lg:p-12">
          <div className="mb-10">
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan mb-4">
              Legal
            </div>
            <h1 className="text-4xl sm:text-5xl font-heading font-bold tracking-tight leading-tight mb-4">
              Правовая информация
            </h1>
            <p className="text-muted leading-relaxed max-w-3xl">
              Материалы сайта предназначены для общего ознакомления с платформой InBoost,
              её технологическими возможностями, сценариями внедрения и архитектурными подходами.
            </p>
          </div>

          <Section title="1. Информационный характер материалов">
            <p>
              Материалы, размещенные на сайте inboost.pro, носят исключительно информационный характер
              и предназначены для общего ознакомления с платформой InBoost, архитектурными подходами,
              технологическими возможностями, вариантами внедрения и сценариями использования.
            </p>
            <p>
              Информация, опубликованная на сайте, не является исчерпывающей и не заменяет техническую,
              проектную, договорную, юридическую или иную профессиональную документацию.
            </p>
          </Section>

          <Section title="2. Отсутствие публичной оферты">
            <p>
              Ничто на сайте не является публичной офертой в смысле статьи 437 Гражданского кодекса
              Российской Федерации, если иное прямо не указано в отдельном документе,
              подписанном или опубликованном Оператором.
            </p>
            <p>
              Любые сведения о функциональности, стоимости, сроках внедрения, составе услуг,
              интеграционных возможностях, SLA, показателях эффективности, экономическом эффекте
              и результатах использования решения подлежат отдельному согласованию
              в коммерческой, технической и договорной документации.
            </p>
          </Section>

          <Section title="3. Оценочные и прогнозные сведения">
            <p>
              Сведения об ожидаемых эффектах внедрения, повышении утилизации GPU, снижении TCO,
              ускорении масштабирования, сроках внедрения и иных результатах носят оценочный характер
              и зависят от инфраструктуры заказчика, качества исходных данных, типа ИИ-нагрузки,
              существующего технологического стека и иных факторов.
            </p>
            <p>
              Фактические результаты эксплуатации платформы могут отличаться от приведенных на сайте
              примеров, сценариев, оценок и иллюстраций.
            </p>
          </Section>

          <Section title="4. Ограничение ответственности">
            <p>
              Оператор прилагает разумные усилия для поддержания актуальности и корректности информации,
              размещенной на сайте, однако не гарантирует отсутствие неточностей, опечаток, временной
              неполноты или устаревания отдельных материалов.
            </p>
            <p>
              Оператор не несет ответственности за убытки, возникшие вследствие использования
              или невозможности использования материалов сайта, если иное прямо не предусмотрено
              применимым законодательством или письменным соглашением сторон.
            </p>
          </Section>

          <Section title="5. Интеллектуальная собственность">
            <p>
              Все тексты, графические элементы, структура сайта, фирменные обозначения, логотипы,
              технические описания и иные материалы сайта являются объектами интеллектуальных прав
              и не могут использоваться без предварительного письменного разрешения правообладателя,
              за исключением случаев, прямо предусмотренных законодательством Российской Федерации.
            </p>
          </Section>

          <Section title="6. Конфиденциальная информация">
            <p>
              Не направляйте через открытые каналы связи, опубликованные на сайте, персональные данные
              третьих лиц, сведения, составляющие коммерческую тайну, служебную тайну, конфиденциальную
              информацию, экспортно-контролируемые сведения и иные данные ограниченного доступа
              без наличия надлежащих правовых оснований и предварительного согласования порядка их передачи.
            </p>
          </Section>

          <Section title="7. Внешние ресурсы">
            <p>
              Сайт может содержать ссылки на внешние ресурсы. Оператор не контролирует содержание,
              доступность и правовые условия использования сайтов третьих лиц и не несет ответственности
              за информацию, размещенную на таких ресурсах.
            </p>
          </Section>

          <Section title="8. Контакты">
            <p>
              По вопросам использования материалов сайта и правовой информации:{" "}
              <a
                href="mailto:inbound@inboost.pro"
                className="text-brand-cyan hover:text-brand-cyan/80 transition-colors"
              >
                inbound@inboost.pro
              </a>
              .
            </p>
          </Section>
        </div>
      </div>
    </main>
  );
}